module.exports = __webpack_public_path__ + "img/arrow-prev.7a955e25.svg";